import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEttersendelser as getEttersendelserAction } from "../../../actions/ettersendelserActions";
import { handleChangeAll as handleChangeAllAction } from "../../../actions/handleChangeAction";
import * as title from "../../../constants/titles";
import {
  getEttersendelseQueryParameters,
  getEttersendelseTableRows,
} from "../../../selectors/ettersendelserSelector";
import Utskrift from "../Utskrift";

const ileggelseTableHeaders = [
  "Ilegg.nr.",
  "Ilegg.dato",
  "Klokkeslett",
  "Tjenestenr.",
  "Overt.kode",
  "Kj.merke",
  "Nasjon",
  "Gatenavn",
  "Gatenr.",
  "Bilde",
  "Ettersendelsesrapport",
  "Tilbakemelding",
];

export default function UtskriftContainer() {
  const dispatch = useDispatch();
  const ileggelseTableRows = useSelector(getEttersendelseTableRows);
  const queryParameters = useSelector(getEttersendelseQueryParameters);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = title.ileggelse.ettersendelser;
    const sessionStoragePrintData = JSON.parse(
      window.sessionStorage.getItem("printData"),
    );
    dispatch(
      handleChangeAllAction(
        "ETTERSENDELSER_FILTER_FORM",
        sessionStoragePrintData.queryData,
      ),
    );
    dispatch(
      getEttersendelserAction(
        { ...sessionStoragePrintData.queryData, isElsparksykkelGebyr: false },
        sessionStoragePrintData.paginationData.page,
        sessionStoragePrintData.paginationData.count,
      ),
    ).then(() => {
      setTimeout(() => {
        window.print();
        window.close();
      }, 1000);
    });

    return () => {
      window.sessionStorage.removeItem("printData");
    };
  }, []);

  return (
    <Utskrift
      title="Ettersendelser"
      ileggelseTableHeaders={ileggelseTableHeaders}
      ileggelseTableRows={ileggelseTableRows}
      queryParameters={queryParameters}
    />
  );
}
